import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  AiListeningBrandProfileApiService,
  PromptListParams,
} from 'src/services/aiListeningApi/brandProfile'
import { PromptListResponse } from 'src/services/aiListeningApi/brandProfile.types'

// A freshly added prompt runs within seconds; keep the list current while
// any of its checks is in flight so the card stops saying "pending".
const PENDING_POLL_INTERVAL = 10000

const hasPendingCheck = (data?: PromptListResponse) =>
  !!data?.prompts.some((prompt) => prompt.checkState === 'pending')

export const useGetAiListeningProfilePromptsQuery = (
  profileId: string | undefined,
  { context, search, status }: PromptListParams = {}
) => {
  return useQuery({
    enabled: !!profileId,
    placeholderData: keepPreviousData,
    queryFn: () =>
      AiListeningBrandProfileApiService.getPrompts(profileId ?? '', {
        context,
        search,
        status,
      }),
    queryKey: [
      QueryKey.GET_AI_LISTENING_PROFILE_PROMPTS,
      profileId,
      status ?? 'all',
      search ?? '',
      (context ?? []).join(','),
    ],
    refetchInterval: (query) =>
      hasPendingCheck(query.state.data) ? PENDING_POLL_INTERVAL : false,
  })
}
